import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import PoolsPage from './pages/PoolsPage';
import MinersPage from './pages/MinersPage';
import BlocksPage from './pages/BlocksPage';
import HelpPage from './pages/HelpPage';
import MinerStatsPage from './pages/MinerStatsPage';
import ConnectPage from './pages/ConnectPage';
import Footer from './components/Footer';
import './App.css';
import './themes.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [currentPool, setCurrentPool] = useState<string | null>(null);
  const [currentMiner, setCurrentMiner] = useState<string | null>(null);

  useEffect(() => {
    // Handle hash-based routing
    const handleHashChange = () => {
      const hash = window.location.hash;
      
      // Handle query parameters by splitting on ? first
      const hashBase = hash.split('?')[0];
      const parts = hashBase.split('/').filter(Boolean);
      
      console.log('Hash change:', hash, 'Parts:', parts);
      
      if (parts.length === 0 || parts[0] === '#') {
        setCurrentPage('home');
        setCurrentPool(null);
        setCurrentMiner(null);
      } else if (parts.length >= 2 && parts[1] === 'miner' && parts[2]) {
        // #/poolId/miner/address
        setCurrentPool(parts[0].replace('#', ''));
        setCurrentMiner(parts[2]);
        setCurrentPage('miner-stats');
      } else if (parts.length >= 2 && parts[1] === 'pool') {
        // #/pool/poolId
        setCurrentPool(parts[2]);
        setCurrentPage('pool-details');
      } else {
        // Simple page navigation - handle query parameters
        const page = parts[0].replace('#', '');
        setCurrentPage(page);
        setCurrentPool(null);
        setCurrentMiner(null);
      }
    };

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    
    // Handle initial hash
    handleHashChange();
    
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    setCurrentPool(null);
    setCurrentMiner(null);
    window.location.hash = page === 'home' ? '' : `#${page}`;
  };

  const handlePoolSelect = (poolId: string) => {
    setCurrentPool(poolId);
    setCurrentPage('pool-details');
    window.location.hash = `#pool/${poolId}`;
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onPoolSelect={handlePoolSelect} />;
      case 'dashboard':
        return <DashboardPage />;
      case 'pools':
        return <PoolsPage onPoolSelect={handlePoolSelect} />;
      case 'miners':
        return <MinersPage />;
      case 'blocks':
        return <BlocksPage />;
      case 'help':
        return <HelpPage />;
      case 'connect':
        return <ConnectPage />;
      case 'miner-stats':
        return currentPool && currentMiner ? (
          <MinerStatsPage poolId={currentPool} minerAddress={currentMiner} />
        ) : (
          <HomePage onPoolSelect={handlePoolSelect} />
        );
      default:
        return <HomePage onPoolSelect={handlePoolSelect} />;
    }
  };

  return (
    <div className="App">
      <Header currentPage={currentPage} onNavigate={handleNavigate} />
      
      <main className="main">
        <div className="container">
          {renderCurrentPage()}
        </div>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
